export default {
  // ContactGroupTriggerAdd - this message requests triggering (fires before) adding a contact to a group
  'trigger.cmd.add.contacts_to_groups': { description: 'was added to contact group' },

  // ContactGroupTriggerRemove - this message requests triggering (fires before) removing a contact from a group
  'trigger.cmd.remove.contacts_from_groups': { description: 'was removed from contact group' },

  // ContactGroupTriggerMove - this message requests triggering (fires before) moving a contact from one group to another
  'trigger.cmd.move.contacts_btwn_groups': { description: 'was moved between contact groups' },

  // EmailSendWithPayload - this message requests triggering (fires before) emailing a contact with payload
  'trigger.cmd.send.email_with_payload': { description: '' },

  // EmailSendStored - this message requests triggering (fires before) emailing a contact
  'trigger.cmd.send.email_stored': { description: '' },

  // SmsSendStored - this message requests triggering (fires before) sending an sms to a contact
  'trigger.cmd.send.sms': { description: '' },

  // CreateToDoTrigger Giselle Eisenberg Giselle Eisenbergr - this message requests triggering (fires before) creating a todo
  'trigger.cmd.create.todo': { description: '' },

  // // ImminentDelayTask - this message requests triggering (fires before) a reload of delay tasks in the delay task processor
  // // 							when the stage_eventgoal_processor finds a task that needs to be triggered
  // // 							in the next X number of seconds (soon)
  // 'trigger.cmd.reload.delay_tasks': { description: '' },

  // ContactsAddedToGroup is fired when a contact is associated to a contact group
  'api.association.associate.contact': { description: 'was added to a contact group' },

  // ContactsRemovedFromGroup is fired when a contact is unassociated from a contact group
  'api.association.remove.contact': { description: 'was removed from contact group' },

  // {source}.{type}.{action}.{entity_type}

  // CampaignStatusChange is fired when a campaign status changes
  'api.crud.update.campaign_status': { description: '' },

  // TaskUpdated is fired when a task is updated
  'api.crud.update.task': { description: '' },

  // ContactInsert is fired when a new contact is inserted
  'api.crud.insert.contact': { description: '' },

  // ContactUpdate is fired when a contact is updated
  'api.crud.update.contact': { description: 'was updated' },

  // ContactDelete is fired when a contact is deleted
  'api.crud.delete.contact': { description: 'was deleted' },

  // ContactGroupInsert is fired when a contactgroup is created
  'api.crud.insert.contactgroup': { description: '' },

  // ContactGroupUpdate is fired when a contactgroup is updated
  'api.crud.update.contactgroup': { description: '' },

  // ContactGroupDelete is fired when a contactgroup is deleted
  'api.crud.delete.contactgroup': { description: '' },

  // EmailTemplateInsert is fired when an email template is inserted
  'api.crud.insert.email_template': { description: '' },

  // EmailTemplateUpdate is fired when an email template is updated
  'api.crud.update.email_template': { description: '' },

  // EmailTemplateDelete is fired when an email template is deleted
  'api.crud.delete.email_template': { description: '' },

  // AccountCreated is fired when an account is created
  'api.crud.create.account': { description: '' },

  // EmailSesSnsSend is fired when we receive the Send callback event from SES
  'event.email.ses.send': { description: 'was sent an email' },

  // EmailSesSnsClick is fired when we receive the Click callback event from SES
  'event.email.ses.click': { description: 'clicked an email' },

  // EmailSesSnsOpen is fired when we receive the Open callback event from SES
  'event.email.ses.open': { description: 'opened an email' },

  // EmailSesSnsBounce is fired when we receive the Bounce callback event from SES
  'event.email.ses.bounce': { description: 'had an email bounced' },

  // EmailSesSnsComplaint is fired when we receive the Complaint callback event from SES
  'event.email.ses.complaint': { description: '' },

  // EmailSesSnsReject is fired when we receive the Reject callback event from SES
  'event.email.ses.reject': { description: 'had an email rejected' },

  // EmailSesSnsRenderFail is fired when we receive the RenderFail callback event from SES indicating a bad template or bad substitution variables were supplied
  'event.email.ses.render_fail': { description: '' },

  // EmailInboundOK is fired when we receive a valid inbound email
  'event.email.ses.in_ok': { description: 'received email' },

  // EmailInboundSPAM is fired when we receive an inbound email containing SPAM
  'event.email.ses.in_spam': { description: '' },

  // EmailInboundVIRUS is fired when we receive an inbound email containing a virus
  'event.email.ses.in_virus': { description: '' },

  // EmailOutboundSendNow is fired when email send now is called
  'event.email.ses.out_now': { description: '' },

  // SmsPreSend is fired for a send SMSM now event before it is pushed to Twilio
  'event.sms.all.presend': { description: '' },

  // SmsTwilioAccepted is fired when we receive the accepted callback event from Twilio
  'event.sms.twilio.accepted': { description: '' },

  // SmsTwilioQueued is fired when we receive the queued callback event from Twilio
  'event.sms.twilio.queued': { description: '' },

  // SmsTwilioSending is fired when we receive the sending callback event from Twilio
  'event.sms.twilio.sending': { description: '' },

  // SmsTwilioSent is fired when we receive the sent callback event from Twilio
  'event.sms.twilio.sent': { description: 'was sent a text message' },

  // SmsTwilioReceiving is fired when we receive the receiving callback event from Twilio
  'event.sms.twilio.receiving': { description: 'received text message' },

  // SmsTwilioReceived is fired when we receive the received callback event from Twilio
  'event.sms.twilio.received': { description: '' },

  // SmsTwilioDelivered is fired when we receive the delivered callback event from Twilio
  'event.sms.twilio.delivered': { description: '' },

  // SmsTwilioUndelivered is fired when we receive the undelivered callback event from Twilio
  'event.sms.twilio.undelivered': { description: '' },

  // SmsTwilioFailed is fired when we receive the failed callback event from Twilio
  'event.sms.twilio.failed': { description: '' },

  // SmsTwilioInbound is fired when we receive an inbound SMS from Twilio
  'event.sms.twilio.inbound': { description: '' },

  // PhoneCallInbound is fired when an inbound phone call is initiated
  'event.phonecall.twilio.inbound': { description: 'called' },

  // PhoneCallInboundEnded is fired when we receive the end of call event from Twilio
  'event.phonecall.twilio.inbound_end': { description: 'call ended' },

  // PhoneCallOutboundStart is fired when we initiate an outbound call
  'event.phonecall.twilio.outbound_start': { description: 'call started' },

  // PhoneCallOutboundEnded is fired when we receive the end of call event from Twilio
  'event.phonecall.twilio.outbound_end': { description: 'call ended' },

  // CognitoNewUser is fired after a new Cognito user has been created
  'event.cognito.create.user': { description: '' },

  // BrainTreeSubscrActive is fired by a Lambda function when an account becomes active
  'event.braintree.subscription.active': { description: '' },

  // BrainTreeSubscrInTrial is fired by a Lambda function when an account becomes in trial period active
  'event.braintree.subscription.intrial': { description: '' },

  // BrainTreeSubscrNotInTrial is fired by a Lambda function when an account trial period is over
  'event.braintree.subscription.nottrial': { description: '' },

  // BrainTreeSubscrCanceled is fired by a Lambda function when an account is canceled
  'event.braintree.subscription.canceled': { description: '' },

  // BrainTreeSubscrPastDue is fired by a Lambda function when an account payment is pastdue
  'event.braintree.subscription.pastdue': { description: '' },

  // BrainTreeSubscrPending is fired by a Lambda function when an account payment is pending
  'event.braintree.subscription.pending': { description: '' },

  // BrainTreeSubscrExpired is fired by a Lambda function when an account payment method is expired
  'event.braintree.subscription.expired': { description: '' },

  // UnsubscribeRequest is fired when we receive an unsubscribe request
  'api.unsubscribe.update.contact': { description: '' },

  // SignupFormSubmittal is fired when a signup form is submitted
  'event.signup.submit.contact': { description: '' },

  // SignupPageView is fired when a signup form pageview takes place
  'event.cloudfront.request.pageview_signup': { description: '' },
}
